export const DETAIL_GET_COMMENT_LIST_REQUEST = 'DETAIL_GET_COMMENT_LIST_REQUEST';
export const DETAIL_GET_COMMENT_LIST_SUCCESS = 'DETAIL_GET_COMMENT_LIST_SUCCESS';
export const DETAIL_GET_COMMENT_LIST_FAILURE = 'DETAIL_GET_COMMENT_LIST_FAILURE';

export const DETAIL_GET_GRADE_REQUEST = 'DETAIL_GET_GRADE_REQUEST';
export const DETAIL_GET_GRADE_SUCCESS = 'DETAIL_GET_GRADE_SUCCESS';
export const DETAIL_GET_GRADE_FAILURE = 'DETAIL_GET_GRADE_FAILURE';

export const DETAIL_ADD_COMMENT_REQUEST = 'DETAIL_ADD_COMMENT_REQUEST';
export const DETAIL_ADD_COMMENT_SUCCESS = 'DETAIL_ADD_COMMENT_SUCCESS';
export const DETAIL_ADD_COMMENT_FAILURE = 'DETAIL_ADD_COMMENT_FAILURE';

export const DETAIL_ADD_ZAN_REQUEST = 'DETAIL_ADD_ZAN_REQUEST';
export const DETAIL_ADD_ZAN_SUCCESS = 'DETAIL_ADD_ZAN_SUCCESS';
export const DETAIL_ADD_ZAN_FAILURE = 'DETAIL_ADD_ZAN_FAILURE';

export const USER_SCORE_FORSTORE_REQUEST = 'USER_SCORE_FORSTORE_REQUEST';
export const USER_SCORE_FORSTORE_SUCCESS = 'USER_SCORE_FORSTORE_SUCCESS';
export const USER_SCORE_FORSTORE_FAILURE = 'USER_SCORE_FORSTORE_FAILURE';

// 搜索专题
export const COMMENT_GET_ZT_LIST_REQUEST = 'COMMENT_GET_ZT_LIST_REQUEST';
export const COMMENT_GET_ZT_LIST_SUCCESS = 'COMMENT_GET_ZT_LIST_SUCCESS';
export const COMMENT_GET_ZT_LIST_FAILURE = 'COMMENT_GET_ZT_LIST_FAILURE';

// 搜索应用
export const COMMENT_GET_APP_LIST_REQUEST = 'COMMENT_GET_APP_LIST_REQUEST';
export const COMMENT_GET_APP_LIST_SUCCESS = 'COMMENT_GET_APP_LIST_SUCCESS';
export const COMMENT_GET_APP_LIST_FAILURE = 'COMMENT_GET_APP_LIST_FAILURE';

// 获取评论详情
export const COMMENT_GET_INFO_REQUEST = 'COMMENT_GET_INFO_REQUEST';
export const COMMENT_GET_INFO_SUCCESS = 'COMMENT_GET_INFO_SUCCESS';
export const COMMENT_GET_INFO_FAILURE = 'COMMENT_GET_INFO_FAILURE';

// 获取评论上传图片参数
export const COMMENT_GET_UP_PARAMS_REQUEST = 'COMMENT_GET_UP_PARAMS_REQUEST';
export const COMMENT_GET_UP_PARAMS_SUCCESS = 'COMMENT_GET_UP_PARAMS_SUCCESS';
export const COMMENT_GET_UP_PARAMS_FAILURE = 'COMMENT_GET_UP_PARAMS_FAILURE';

// 添加/修改评论
export const COMMENT_ADD_CONENT_REQUEST = 'COMMENT_ADD_CONENT_REQUEST';
export const COMMENT_ADD_CONENT_SUCCESS = 'COMMENT_ADD_CONENT_SUCCESS';
export const COMMENT_ADD_CONENT_FAILURE = 'COMMENT_ADD_CONENT_FAILURE';